export default {
    getValidationMessage : (state)=> (validationCode)=> { 
        return (state.validationMessages.find(m => m.id == validationCode) || {}).name;
    }
}